import { HomepageMerchandisingContent } from "./types";

// Manager Homepage Banner and Modals
export const WEEKLY_CHECK_IN_MANAGER_MERCHANDISING_CONTENT: HomepageMerchandisingContent =
  {
    banner: {
      title: "Coach Bo is Your Team Development Partner",
      description:
        "Real-time check-in data powers AI-driven insights about each team member's wellbeing, competency development, and coaching needs so you can be the manager your team actually wants.",
      ctaText: "Learn more",
    },
    howItWorks: {
      title: "How It Works",
      bullets: [
        "Your team completes regular check-ins that capture energy patterns and work experiences in real-time",
        "Coach Bo analyzes responses and maps them to competency frameworks for each individual",
        "You receive actionable coaching insights and conversation starters for every team member",
      ],
      quote: {
        text: "I stopped guessing what my team needed and started coaching based on actual data about their work patterns.",
        author: "Engineering Manager — Criteria Corp",
      },
    },
    whyYouNeedIt: {
      title: "Why You Need It",
      bullets: [
        "Transform 1:1s from status updates into meaningful development conversations",
        "Catch burnout and disengagement 2-3 weeks before traditional methods would detect them",
        "Give your team voice and visibility while getting structured feedback that improves team performance",
      ],
      quote: {
        text: "My team participation went up because they finally felt heard - and I got better at supporting each person's unique style.",
        author: "Sales Team Lead — Criteria Corp",
      },
    },
    whatToExpect: {
      title: "What You Can Expect",
      bullets: [
        "60%+ participation as team members see personal value from Coach Bo's insights",
        "Early warning system for retention risks and identification of high-potential team members",
        "Performance review integration that uses real work patterns instead of subjective evaluations",
      ],
      quote: {
        text: "I went from dreading performance reviews to having meaningful career development conversations backed by months of data.",
        author: "Product Manager — Criteria Corp",
      },
    },
  };

// Individual Contributor Homepage Banner and Modals
export const WEEKLY_CHECK_IN_IC_MERCHANDISING_CONTENT: HomepageMerchandisingContent =
  {
    banner: {
      title: "Turn Check-ins into Career Acceleration",
      description:
        "AI-powered coaching that helps you understand your strengths, energy patterns, and development opportunities through simple, regular conversations.",
      ctaText: "Learn more",
    },
    howItWorks: {
      title: "How It Works",
      bullets: [
        "Invite: You get a 2-minute check-in via email",
        "Personal Insights: Coach Bo analyzes your responses and sends you personalized coaching",
        "Career Development: Monthly emails help you understand your strengths, motivators, and growth opportunities",
      ],
      quote: {
        text: "Coach Bo helped me realize my natural problem-solving approach was actually a leadership strength I could develop further.",
        author: "Sarah Chen, Software Engineer — Criteria Corp",
      },
    },
    whyYouNeedIt: {
      title: "Why You Need It",
      bullets: [
        "Get personalized coaching without waiting for your manager to provide it",
        "Understand your energy patterns and what motivates you at work",
        "Build a development profile you can use in 1:1s and performance reviews",
        "Access 24/7 private coaching conversations whenever you need support",
      ],
      quote: {
        text: "I finally understand what energizes me at work and can advocate for projects that match my strengths.",
        author: "Marcus Rodriguez, Product Designer — Criteria Corp",
      },
    },
    whatToExpect: {
      title: "What You Can Expect",
      bullets: [
        "Personal development insights delivered directly to your email",
        "Career coaching based on your actual work patterns and goals",
        "Private, confidential conversations with Coach Bo whenever you need guidance",
        "Competency tracking that helps you see your professional growth over time",
      ],
      quote: {
        text: "The 90-day development profile Coach Bo created became the foundation for my promotion conversation.",
        author: "Jennifer Park, Marketing Manager — Criteria Corp",
      },
    },
  };

export const WEEKLY_CHECK_IN_ADMIN_MERCHANDISING_CONTENT: HomepageMerchandisingContent =
  {
    banner: {
      title: "Turn Check-ins Into Management Superpowers",
      description:
        "AI-powered conversations that give managers actionable insights and early warnings about their team's wellbeing and performance.",
      ctaText: "Learn more",
    },
    howItWorks: {
      title: "How It Works",
      bullets: [
        "Invite: Employees get emailed and complete a 2 minute check-in",
        "Following Completion: Coach Bo processes the responses",
        "After Completion: Managers receive email reports and conversation summaries",
      ],
      quote: {
        text: "I shared personal challenges with Bo and my manager reached out the same day.",
        author: "Team Member — Criteria Corp",
      },
    },
    whyYouNeedIt: {
      title: "Why You Need It",
      bullets: [
        "No more 'How was your week?' guesswork",
        "Catch issues before they become crises",
        "Works in the tools you use every day (email currently with Slack/Teams coming soon)",
      ],
      quote: {
        text: "In the first week, I learned things my department leaders hadn't heard yet.",
        author: "Josh Millet, CEO — Criteria",
      },
    },
    whatToExpect: {
      title: "What You Can Expect",
      bullets: [
        "Have meaningful 1:1s instead of status updates",
        "50%+ participation across teams",
        "Issues identified 2-4 weeks earlier than traditional methods",
      ],
      quote: {
        text: "We've seen 20X more engagement and can build a proactive people strategy.",
        author: "Jillian Phelan, CPO — Criteria",
      },
    },
  };
